export const DEFAULT_TITLE = "Kick";

export function applyDocumentTitle(title: string): void {
    document.title =
        title === DEFAULT_TITLE ? DEFAULT_TITLE : `${title} | ${DEFAULT_TITLE}`;
}
